export enum AvailableLanguages {
  'en-gb' = 'GB',
  fr = 'FR',
  it = 'IT',
  es = 'ES',
}
